module.exports = __webpack_public_path__ + "static/media/download_file.c4c38d95.svg";